import Api from './baseApi';

export default {
  getGoldPrice: () => Api.get('/api/gold-price'),
};
